import {HISTORY_QUOTES} from "./history";
import {AQUARS_QUOTES} from "./factions/aquars";
import {BEASTMEN_QUOTES} from "./factions/beastmen";
import {CELECTIALS_QUOTES} from "./factions/celectials";
import {DARK_ELVES_QUOTES} from "./factions/dark_elves";
import {DEMONS_QUOTES} from "./factions/demons";
import {DOPPLERS_QUOTES} from "./factions/dopplers";
import {DRAGONS_QUOTES} from "./factions/dragons";
import {DWARVES_QUOTES} from "./factions/dwarves";
import {ELEMENTALS_QUOTES} from "./factions/elementals";
import {GREMLINS_QUOTES} from "./factions/gremlins";
import {GOBLINS_QUOTES} from "./factions/goblins";
import {INSECTOIDS_QUOTES} from "./factions/insectoids";
import {GIANTS_QUOTES} from "./factions/giants";
import {LEPRECHAUNS_QUOTES} from "./factions/leprechauns";
import {FENIX_QUOTES} from "./factions/fenix";
import {MUSHROOM_PEOPLE_QUOTES} from "./factions/mushroom_people";
import {ENTS_QUOTES} from "./factions/ents";
import {ELVES_QUOTES} from "./factions/elves";
import {HUMANS_QUOTES} from "./factions/humans";
import {ORCS_QUOTES} from "./factions/orcs";
import {RATMEN_QUOTES} from "./factions/ratmen";
import {SPIRITS_QUOTES} from "./factions/spirits";
import {SUCCUBES_QUOTES} from "./factions/succubes";
import {TECHNODWARVES_QUOTES} from "./factions/technodwarves";
import {UNDEAD_QUOTES} from "./factions/undead";
import {VENTORY_QUOTES} from "./factions/ventory";
import {WIZARDS_QUOTES} from "./factions/wizards";
import {ENLIGHTENED_QUOTES} from "./factions/enlightened";

export const QUOTES = [
  ...HISTORY_QUOTES,
  ...AQUARS_QUOTES,
  ...BEASTMEN_QUOTES,
  ...CELECTIALS_QUOTES,
  ...DARK_ELVES_QUOTES,
  ...DEMONS_QUOTES,
  ...DOPPLERS_QUOTES,
  ...DRAGONS_QUOTES,
  ...DWARVES_QUOTES,
  ...ELEMENTALS_QUOTES,
  ...ELVES_QUOTES,
  ...ENLIGHTENED_QUOTES,
  ...ENTS_QUOTES,
  ...FENIX_QUOTES,
  ...GIANTS_QUOTES,
  ...GOBLINS_QUOTES,
  ...GREMLINS_QUOTES,
  ...HUMANS_QUOTES,
  ...INSECTOIDS_QUOTES,
  ...LEPRECHAUNS_QUOTES,
  ...MUSHROOM_PEOPLE_QUOTES,
  ...ORCS_QUOTES,
  ...RATMEN_QUOTES,
  ...SPIRITS_QUOTES,
  ...SUCCUBES_QUOTES,
  ...TECHNODWARVES_QUOTES,
  ...UNDEAD_QUOTES,
  ...VENTORY_QUOTES,
  ...WIZARDS_QUOTES,
]